import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap, Package } from 'lucide-react';

function ProductCard({ product }) {
  const navigate = useNavigate();

  // 이미지 URL 가져오기 (image_urls 배열 우선, 없으면 image_url 사용)
  const getImageUrl = () => {
    if (product.image_urls && product.image_urls.length > 0) {
      return product.image_urls[0];
    }
    return product.image_url || '/placeholder.png';
  };

  const imageCount = product.image_urls?.length || (product.image_url ? 1 : 0);

  return (
    <div
      onClick={() => navigate(`/product/${product.uuid}`)}
      className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg hover:border-gray-300 transition-all cursor-pointer group"
    >
      <div className="relative aspect-square bg-gray-100">
        <img
          src={getImageUrl()}
          alt={product.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/400x400?text=No+Image';
          }}
        />

        {/* 빠른 배송 뱃지 */}
        {product.has_fast_shipping && (
          <span className="absolute top-3 left-3 bg-teal-500 text-white text-xs font-semibold px-2.5 py-1 rounded-full flex items-center gap-1 shadow-md">
            <Zap className="w-3 h-3" />
            빠른 배송
          </span>
        )}

        {/* 이미지 개수 뱃지 */}
        {imageCount > 1 && (
          <span className="absolute top-3 right-3 bg-black/60 text-white text-xs px-2 py-1 rounded-full">
            +{imageCount - 1}
          </span>
        )}
      </div>

      <div className="p-4">
        <h3 className="text-base font-semibold text-gray-900 mb-1 truncate group-hover:text-teal-600 transition-colors">
          {product.name}
        </h3>
        <p className="text-gray-500 text-sm mb-3 line-clamp-2 min-h-[2.5rem]">
          {product.description || '상품 설명이 없습니다.'}
        </p>

        <div className="flex justify-between items-end">
          <span className="text-xl font-bold text-teal-600">
            {product.options && product.options.length > 0
              ? (() => {
                  const prices = product.options.map(o => o.price);
                  const min = Math.min(...prices);
                  const max = Math.max(...prices);
                  return min === max ? `${min.toLocaleString()}원` : `${min.toLocaleString()}원~`;
                })()
              : `${product.price.toLocaleString()}원`
            }
          </span>

          {product.has_fast_shipping && (
            <div className="flex items-center gap-1 text-xs text-gray-400">
              <Package className="w-3.5 h-3.5" />
              {product.options && product.options.length > 0
                ? <span>옵션별 재고 상이</span>
                : <span>재고 {product.fassto_stock_qty}개</span>
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
